"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.pagination.step': 'Paso',
    'onboarding.pagination.step.1': 'Paso 1',
    'onboarding.pagination.navigation': 'Navegación de Onboarding',
};
